/* Package JSON Import will be here */
import { isEmpty } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { applyFilterApi } from "services/products";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { initializeOrderState } from "../orders";
import { getErrorObject, mergeMultipleSchemeProducts, normalizeByGroup, errorToast } from 'utilities/utils';
import { GAViewItem } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

export const types = {
    PRODUCT_DERAILS_UPDATE_IS_FAV: "ProductDetails/PRODUCT_DERAILS_UPDATE_IS_FAV",
    PRODUCT_DERAILS_REQUEST: "ProductDetails/PRODUCT_DERAILS_REQUEST",
    PRODUCT_DERAILS_SUCCESS: "ProductDetails/PRODUCT_DERAILS_SUCCESS",
    PRODUCT_DERAILS_FAILURE: "ProductDetails/PRODUCT_DERAILS_FAILURE",
    RESET_PRODUCT_DETAILS: "ProductDetails/RESET_PRODUCT_DETAILS"
};

const initialState = {
    groupIds: [],
    group: {},
    isDataLoaded: false,
    ids: [],
    data: {},
    error: null
};

export const productDetails = (state = initialState, action) => {
    switch (action.type) {
        case types.PRODUCT_DERAILS_REQUEST:
            return {
                ...initialState
            };

        case types.PRODUCT_DERAILS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isDataLoaded: true
            };

        case types.PRODUCT_DERAILS_FAILURE:
            return {
                ...initialState,
                isDataLoaded: true,
                error: action.payload.error
            };

        case types.RESET_PRODUCT_DETAILS:
            return {
                ...initialState
            };

        case types.PRODUCT_DERAILS_UPDATE_IS_FAV:
            let { ProductId, IsFavourite } = action.payload;

            if (!isEmpty(state.data) && ProductId in state.data) {
                return {
                    ...state,
                    data: {
                        ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 }
                    },
                    error: null
                };
            }
            else {
                return state;
            }

        default:
            return state;
    }
};


export const getProductDetails = (productId) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.PRODUCT_DERAILS_REQUEST });
        try {
            const requestData = {
                FilterLevelCode: "SKU",
                FilterIdList: [productId],
                Sorting: getState().appSettings.defaultProductSorting,
                NeedAllProducts: true
            };

            /* Make API call to fetch the selected product details */
            const response = await applyFilterApi(requestData);

            /* Merge multiple scheme product into single item */
            const mergedProductList = mergeMultipleSchemeProducts(response.data.Data);

            /* Get products by normalize group */
            let payload = normalizeByGroup({
                data: mergedProductList,
                key: "ProductId",
                groupKey: "GroupId"
            });

            await dispatch({ type: types.PRODUCT_DERAILS_SUCCESS, payload });

            /* Initialize the Apply filter products into the order reducer */
            await dispatch(initializeOrderState(Constants.REDUCER_PRODUCT_DETAILS));
            
            /* GA - Track product view */
            if (window.isEnableGA)
                GAViewItem(payload.data[productId]);
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.PRODUCT_DERAILS_FAILURE, true));
        }
    };
};

/* Reset product details data while the user leave from the product details page */
export const resetProductDetails = () => {
    return async (dispatch, getState) => {
        await dispatch({ type: types.RESET_PRODUCT_DETAILS });
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};